export default __webpack_public_path__ + "static/media/civil_lab1.469ade9b.jpg";